export const PageTitle = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => <div className="flex flex-col gap-[2px]" data-sentry-component="PageTitle" data-sentry-source-file="Page.tsx">
    <h2 className="text-body-md-bold text-alternative">{description}</h2>
    <h1 className="text-heading-xl-extrabold text-default">{title}</h1>
  </div>;